<div class="my-medical-orders-empty-state-container">
    <h2>{{title | translate:locale.language}}</h2>
    <p>{{text | translate:locale.language}}</p>
    <button mat-button mat-flat-button class="primary" routerLink="/doctores">
        {{'shared.medicalOrder.empty.button' | translate:locale.language }}
    </button>
</div>